export default "__VITE_ASSET__Bi0RZ7Bp__"